import { Table } from "antd";
import { get } from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatNumber } from "../../../../../utils/utilities";

const VopTable = ({ vopData }) => {
  const { t } = useTranslation();
  const currentLanguage = useSelector((state) => get(state.languageDuck, "currentLanguage", "GB"));
  const columns = [
    {
      title: "",
      width: 200 + 48, // 48 is the width of the summary table cell with the plus icon
      fixed: "left",
      render: () => t("projectsManagement.planning.billingPlan.PRODUCTION_VALUE"),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.ap"),
      dataIndex: "AP",
      width: 100,
      fixed: "left",
      className: "table-value-right highlighted",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.gen"),
      dataIndex: "JANUARY",
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.feb"),
      dataIndex: "FEBRUARY",
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.mar"),
      dataIndex: "MARCH",
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.apr"),
      dataIndex: "APRIL",
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.may"),
      dataIndex: "MAY",
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.jun"),
      dataIndex: "JUNE",
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.jul"),
      dataIndex: "JULY",
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.aug"),
      dataIndex: "AUGUST",
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.sep"),
      dataIndex: "SEPTEMBER",
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.oct"),
      dataIndex: "OCTOBER",
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.nov"),
      dataIndex: "NOVEMBER",
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.dec"),
      dataIndex: "DECEMBER",
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.as"),
      dataIndex: "AS",
      fixed: "right",
      width: 100,
      className: "table-value-right highlighted",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.tot"),
      dataIndex: "TOT",
      fixed: "right",
      width: 100,
      className: "table-value-right highlighted",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
  ];

  return <Table bordered dataSource={vopData} columns={columns} size="small" pagination={false} scroll={{ x: 1500 }} />;
};

export default VopTable;
